/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React, { useEffect } from "react"
import { Button, Container, H3, Stack } from "@carrotfertility/carotene"
import { CircleImage } from "../CircleImage"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { NoResultMessage } from "./NoResultMessage"
import { providerFinderRootPath } from "../../utils/providerFinderSearchUrl"
import { getHeap } from "../../utils/heap"
import { FormattedMessage } from "react-intl"

const StyledContainer = styled(Container)`
  text-align: center;
`
export function NoResultDisplay({ isCountryCodeNotMatching }: { isCountryCodeNotMatching: boolean }): JSX.Element {
  useEffect(
    function trackProviderSearchNoResultsMessageRendered() {
      getHeap().track("Provider Search No Results Message Rendered", {
        "Location Is Outside Country": isCountryCodeNotMatching ? "true" : "false"
      })
    },
    [isCountryCodeNotMatching]
  )

  return (
    <Stack alignItems="center" width="100%" padding="80px 0 0 0">
      <CircleImage name="icn-find" backgroundColor="lightBlue" size={84} padding={18} />
      <StyledContainer>
        <H3 padding="12px">
          <FormattedMessage defaultMessage="No results found" />
        </H3>
        <NoResultMessage isCountryCodeNotMatching={isCountryCodeNotMatching} />
      </StyledContainer>
      <Link to={providerFinderRootPath}>
        <Button variant="secondary">
          <FormattedMessage defaultMessage="Reset location" />
        </Button>
      </Link>
    </Stack>
  )
}
